import React from 'react';
import styled from 'styled-components';
import SettingsImage from '../../images/settings.svg';
import { sidebarBreakpoint } from '../variables';

const Username = styled.span`
	color: #fff;
	text-transform: capitalize;
	display: inline-block;

	@media (max-width: ${sidebarBreakpoint + 'px'}) {
		display: none;
	}
`;

const Button = styled.button`
	background: transparent;
	display: flex;
	align-items: center;
	border: none;
	outline: 0;
	cursor: pointer;
	margin-top: 0;

	&:hover,
	&:focus {
		> span {
			color: #fff;
			opacity: 0.9;
		}
	}
`;

const SettingsIcon = styled.span`
	background: transparent url(${SettingsImage});
	background-size: 16px;
	background-position: center;
	background-repeat: no-repeat;
	display: block;
	width: 20px;
	height: 20px;
	margin-left: 6px;
	filter: brightness(0) invert(1);
`;

class ProfileButton extends React.Component {
	render() {
		const { user, toggleDropdown } = this.props;

		const fullName = `${user.first_name} ${user.last_name}`;

		return (
			<Button onClick={() => toggleDropdown()}>
				<Username>{fullName}</Username>
				<SettingsIcon />
			</Button>
		);
	}
}

export default ProfileButton;



// WEBPACK FOOTER //
// ./src/components/TopBar/ProfileButton.js